<div class="py-6 bg-surface-secondary">
    <div class="container-fluid max-w-screen-lg vstack gap-6">
        <div class="card md-2" *ngIf="user.role_uuid === ROLES.AGENCY">
            <app-address-component></app-address-component>
        </div>
        <div class="card md-2" *ngIf="user.role_uuid === ROLES.AGENCY">
            <app-bank-details-component></app-bank-details-component>
        </div>
    </div>    
</div>